module.exports = __webpack_public_path__ + "img/file.f0dfa94a.svg";